import React, { useEffect, useState, Fragment } from 'react';
import { PageHeader } from '../../../Common';
import services from '../services';
import TextField from '@material-ui/core/TextField';
import MessageModal from '../../../UI/Modal/MessageModal';
import $ from 'jquery';
import { validateProperty, validate } from "../../Common";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import Joi, { func } from '@hapi/joi';
import { LoadingSpinerComponent } from '../../../Common/loader';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import { maternityLeaveSchema } from '../maternityLeaveSchema';
import { makeStyles } from '@material-ui/core/styles';
import tokenDecoder from '../../../../components/Common/tokenDecoder';
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

const screenCode = 'MATERNITYLEAVE';

const useStyles = makeStyles((theme) => ({
    dateField: {
        width: '100%',
    },
}));

export function MaternityLeaveListing(props) {
    const classes = useStyles();

    const [allMaternityLeaveRecords, setAllMaternityLeaveRecords] = useState([]);
    const [groups, setGroups] = useState();
    const [operationEntities, setOperationEntities] = useState();
    const [collectionPoints, setCollectionPoints] = useState();
    const [leaveTypes, setLeaveTypes] = useState([]);
    const [searchForm, setSearchForm] = useState({
        groupID: 0,
        operationEntityID: 0,
        collectionPointID: 0,
        registrationNumber: '',
        leaveType: 0,
        fromDate: new Date().toISOString().split("T")[0],
        toDate: new Date().toISOString().split("T")[0]
    });
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    });

    const [errors, setErrors] = useState({});
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [isTableHidden, setIsTableHidden] = useState(true);
    const schema = Joi.object(maternityLeaveSchema).options({ allowUnknown: true });

    const [open, setOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [multipleEstates, setMultipleEstates] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions());
    }, []);

    useEffect(() => {
        trackPromise(getOperationEntitiesByGroup());
    }, [searchForm.groupID]);

    useEffect(() => {
        trackPromise(getCollectionPointsForDropDown());
    }, [searchForm.operationEntityID]);

    useEffect(() => {
        trackPromise(getLeaveTypesForDropDown());
    }, [searchForm.operationEntityID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode === 'VIEWMATERNITYLEAVE');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode === 'ADDEDITMATERNITYLEAVE');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode === 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode === 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromTokenV2();
        if (token.operationEntities.length > 0) {
            var estateObject = [];
            for (let item of Object.entries(token.operationEntities)) {
                estateObject[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"];
            }
            setMultipleEstates(estateObject);
            setSearchForm({
                ...searchForm,
                groupID: token.groupID
            });
        } else {
            setSearchForm({
                ...searchForm,
                groupID: token.groupID,
                operationEntityID: token.operationEntityID,
            });
        }
        setSearchForm({
            ...searchForm,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        trackPromise(setGroupDropDownData());
    }

    async function setGroupDropDownData() {
        const result = await services.getGroups();
        setGroups(result);
    }

    async function getOperationEntitiesByGroup() {
        if (searchForm.groupID > 0) {
            let filteredData = await services.getOperationalEntityByGroupEntityID(searchForm.groupID);
            setOperationEntities(filteredData);
        } else {
            setOperationEntities([]);
        }
    }

    async function getLeaveTypesForDropDown() {
        if (searchForm.operationEntityID > 0) {
            const leaveTypeData = await services.getLeaveTypesByOperationEntity(
                searchForm.operationEntityID
            );
            setLeaveTypes(leaveTypeData);
        } else {
            setLeaveTypes([]);
        }
    }

    async function getCollectionPointsForDropDown() {
        if (searchForm.operationEntityID > 0) {
            const collectionPoint = await services.getCollectionPointsByOperationentityGroupID(
                searchForm.operationEntityID,
                searchForm.groupID
            );
            setCollectionPoints(collectionPoint);
        } else {
            setCollectionPoints([]);
        }
    }

    function destroyDataTable() {
        setIsTableHidden(true);
        if ($.fn.DataTable.isDataTable('#maternityTable')) {
            $('#maternityTable').DataTable().destroy();
        }
    }

    function createDataTable() {
        setTimeout(() => {
            $('#maternityTable').DataTable({
                stripeClasses: [],
                "order": [[0, "desc"]],
                "pageLength": 10,
                "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]]
            });
            setIsTableHidden(false);
        }, 100);
    }

    function handleEdit(item) {
        props.history.push({
            pathname: '/maternityLeave/addEdit',
            data: item,
            edit: true
        });
    }

    async function handleDelete() {
        if (!selectedItem) return;

        const model = {
            maternityLeaveID: selectedItem.maternityLeaveID,
            groupID: searchForm.groupID,
            operationEntityID: searchForm.operationEntityID,
            registrationNumber: selectedItem.employeeCode,
            leaveTypeID: selectedItem.leaveTypeID,
            modifiedBy: parseInt(tokenDecoder.getUserIDFromToken())
        };
        const response = await services.deleteMaternityLeave(model);

        if (response.statusCode === "Success") {
            setMessageModel({
                hidden: false,
                type: "Success",
                disciption: response.message
            });

            setTimeout(() => {
                setMessageModel((prevModel) => ({
                    ...prevModel,
                    hidden: true
                }));
            }, 4000);

            handleSearch();
        } else {
            setMessageModel({
                hidden: false,
                type: "Error",
                disciption: response.message
            });

            setTimeout(() => {
                setMessageModel((prevModel) => ({
                    ...prevModel,
                    hidden: true
                }));
            }, 4000);
        }

        setOpen(false);
        setSelectedItem(null);
    }

    function handleClose() {
        setOpen(false);
        setSelectedItem(null);
    }

    function handleClickOpen(item) {
        setSelectedItem(item);
        setOpen(true);
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value;

        const error = { ...errors };

        if (target.name === 'registrationNumber') {
            if (value && !/^[0-9]*$/.test(value)) {
                error.registrationNumber = 'Registration number must be a number';
            } else {
                delete error.registrationNumber;
            }
        } else {
            const errorMessage = validateProperty(target, maternityLeaveSchema);
            errorMessage ? error[target.name] = errorMessage : delete error[target.name];
        }

        setAllMaternityLeaveRecords([]);

        if (target.name === 'groupID') {
            setSearchForm({
                ...searchForm,
                [e.target.name]: value,
                operationEntityID: 0,
                collectionPointID: 0,
                leaveType: 0,
                registrationNumber: '',
                fromDate: new Date().toISOString().split("T")[0],
                toDate: new Date().toISOString().split("T")[0]
            });
        } else if (target.name === 'operationEntityID') {
            setSearchForm({
                ...searchForm,
                [e.target.name]: value,
                collectionPointID: 0,
                leaveType: 0,
                registrationNumber: '',
                fromDate: new Date().toISOString().split("T")[0],
                toDate: new Date().toISOString().split("T")[0]
            });
        } else if (target.name === 'collectionPointID') {
            setSearchForm({
                ...searchForm,
                [e.target.name]: value,
                leaveType: 0,
                registrationNumber: '',
                fromDate: new Date().toISOString().split("T")[0],
                toDate: new Date().toISOString().split("T")[0]
            });
        } else if (target.name === 'leaveType') {
            setSearchForm({
                ...searchForm,
                [e.target.name]: value,
                registrationNumber: '',
                fromDate: new Date().toISOString().split("T")[0],
                toDate: new Date().toISOString().split("T")[0]
            });
        } else if (target.name === 'registrationNumber') {
            setSearchForm({
                ...searchForm,
                [e.target.name]: value,
                fromDate: new Date().toISOString().split("T")[0],
                toDate: new Date().toISOString().split("T")[0]
            });
        } else {
            setSearchForm({
                ...searchForm,
                [e.target.name]: value
            });
        }

        setErrors(error);
    }

    async function handleRegistrationNumberBlur() {
        if (!searchForm.registrationNumber || searchForm.registrationNumber.trim() === '') {
            return true;
        }


        const employee = await services.getEmployeeByRegistrationNumber(
            searchForm.registrationNumber,
            searchForm.groupID,
            searchForm.operationEntityID,
            searchForm.collectionPointID
        );


        if (employee && employee.employeeCode) {
            setSearchForm({
                ...searchForm,
                registrationNumber: employee.employeeCode
            });
            return true;
        } else {
            setSearchForm({
                ...searchForm,
                registrationNumber: ''
            });

            setMessageModel({
                hidden: false,
                type: "Warning",
                disciption: "Please enter a valid registration number and verify the employee exists"
            });

            setTimeout(() => {
                setMessageModel((prevModel) => ({
                    ...prevModel,
                    hidden: true
                }));
            }, 4000);

            return false;
        }
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }
    async function handleSearch(e) {
        if (e !== undefined) {
            e.preventDefault();
            const errorMessages = validate(schema, searchForm);

            if (errorMessages) {
                const filteredErrors = { ...errorMessages };
                delete filteredErrors.leaveType;
                delete filteredErrors.registrationNumber;
                delete filteredErrors.dayCount;
                if (Object.keys(filteredErrors).length > 0) {
                    setErrors(filteredErrors);
                    return;
                }
            }

            setErrors({});
        }

        if (searchForm.registrationNumber && searchForm.registrationNumber.trim() !== '') {
            const isValid = await handleRegistrationNumberBlur();
            if (!isValid) {
                return;
            }
        }

        if (searchForm.groupID !== 0 && searchForm.operationEntityID !== 0) {
            destroyDataTable();
            var maternityRecords = await services.getMaternityLeaveRecords(
                searchForm.groupID,
                searchForm.operationEntityID,
                searchForm.collectionPointID,
                searchForm.registrationNumber,
                searchForm.leaveType,
                searchForm.fromDate,
                searchForm.toDate
            );

            if (maternityRecords && maternityRecords.length > 0) {
                setAllMaternityLeaveRecords(maternityRecords);
                createDataTable();
            } else {
                setAllMaternityLeaveRecords([]);
                setMessageModel({
                    hidden: false,
                    type: "Warning",
                    disciption: "No records found for the selected criteria"
                });

                setTimeout(() => {
                    setMessageModel((prevModel) => ({
                        ...prevModel,
                        hidden: true
                    }));
                }, 4000);
            }
        }
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function handleClear() {
        var token = tokenService.getUserDetailsFromToken();
        setSearchForm({
            groupID: token.groupID,
            operationEntityID: token.operationEntityID,
            collectionPointID: 0,
            leaveType: 0,
            registrationNumber: '',
            fromDate: new Date().toISOString().split("T")[0],
            toDate: new Date().toISOString().split("T")[0]
        });
        setErrors({});
        destroyDataTable();
        setAllMaternityLeaveRecords([]);
    }

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        return dateString.split("T")[0];
    };

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Leave Management"
                            isButtonEnable={permissionList.isAddEditEnabled}
                            buttonText="+ Add Leave"
                            path="/maternityLeave/addEdit"
                        />
                        <div className="card-body">
                            <form onSubmit={(e) => trackPromise(handleSearch(e))}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            name="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            value={searchForm.groupID}
                                            onChange={(e) => handleChange(e)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            value={searchForm.operationEntityID}
                                            onChange={(e) => handleChange(e)}
                                        >
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(
                                                Object.keys(multipleEstates).length === 0 ? operationEntities : multipleEstates
                                            )}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="collectionPointID">Collection Point *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={searchForm.collectionPointID}
                                            onChange={(e) => handleChange(e)}
                                        >
                                            <MenuItem value="0">--Select Collection Point--</MenuItem>
                                            {generateDropDownMenu(collectionPoints)}
                                        </Select>
                                        {errors["collectionPointID"] && <FormHelperText className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="leaveType">Leave Type</InputLabel>
                                        <Select
                                            fullWidth
                                            id="leaveType"
                                            name="leaveType"
                                            value={searchForm.leaveType}
                                            onChange={(e) => handleChange(e)}
                                        >
                                            <MenuItem value="0">--Select Leave Type--</MenuItem>
                                            {generateDropDownMenu(leaveTypes)}
                                        </Select>
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="registrationNumber">Registration Number</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="registrationNumber"
                                            name="registrationNumber"
                                            value={searchForm.registrationNumber}
                                            onChange={(e) => handleChange(e)}
                                            onKeyPress={(e) => {
                                                if (!/[0-9]/.test(e.key)) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            placeholder="Enter Registration Number"
                                        />
                                        {errors["registrationNumber"] && <FormHelperText className="text text-danger">{errors["registrationNumber"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="fromDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            value={searchForm.fromDate}
                                            onChange={(e) => handleChange(e)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            className={classes.dateField}
                                        />
                                        {errors["fromDate"] && <FormHelperText className="text text-danger">{errors["fromDate"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="toDate">To Date</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            value={searchForm.toDate}
                                            onChange={(e) => handleChange(e)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            className={classes.dateField}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md-12 text-right">
                                        <button
                                            type="button"
                                            className="btn btn-warning mr-2"
                                            onClick={handleClear}
                                        >
                                            CLEAR
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                        >
                                            SEARCH
                                        </button>
                                    </div>
                                </div>
                            </form>
                            {allMaternityLeaveRecords.length > 0 ? (
                                <div className="table-responsive row-top-gap">
                                    <table id="maternityTable" hidden={isTableHidden} className="display dataTable no-footer">
                                        <thead>
                                            <tr>
                                                <th>Employee Code</th>
                                                <th>Employee Name</th>
                                                <th>Leave Type</th>
                                                <th style={{ textAlign: 'center' }}>From Date</th>
                                                <th style={{ textAlign: 'center' }}>To Date</th>
                                                {permissionList.isAddEditEnabled ? <th style={{ textAlign: 'center' }}>Actions</th> : null}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {allMaternityLeaveRecords.map((row, index) => (
                                                <tr key={row.maternityLeaveID || index}>
                                                    <td align="left" style={{ padding: '8px' }}>
                                                        {row.employeeCode || '-'}
                                                    </td>
                                                    <td align="left" style={{ padding: '8px' }}>
                                                        {row.employeeName || '-'}
                                                    </td>
                                                    <td align="left" style={{ padding: '8px' }}>
                                                        {row.leaveTypeName || '-'}
                                                    </td>
                                                    <td align="center" style={{ padding: '8px' }}>
                                                        {formatDate(row.fromDate)}
                                                    </td>
                                                    <td align="center" style={{ padding: '8px' }}>
                                                        {formatDate(row.toDate)}
                                                    </td>
                                                    {permissionList.isAddEditEnabled && (
                                                        <td align="center" style={{ padding: '8px' }}>
                                                            <button
                                                                onClick={() => handleEdit(row)}
                                                                style={{ cursor: "pointer", marginRight: '20px' }}
                                                                title="Edit"
                                                            >
                                                                <i className="fa fa-edit"></i>
                                                            </button>
                                                            <button
                                                                onClick={() => handleClickOpen(row)}
                                                                style={{ cursor: "pointer" }}
                                                                title="Delete"
                                                            >
                                                                <i className="fa fa-trash"></i>
                                                            </button>
                                                        </td>
                                                    )}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Delete Leave"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this leave record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        No
                    </Button>
                    <Button onClick={handleDelete} color="primary" autoFocus>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}